import { render, staticRenderFns } from "./ProcessExceptionsPreview.vue?vue&type=template&id=48809791"
import script from "./ProcessExceptionsPreview.vue?vue&type=script&lang=js"
export * from "./ProcessExceptionsPreview.vue?vue&type=script&lang=js"
import style0 from "./ProcessExceptionsPreview.vue?vue&type=style&index=0&id=48809791&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports